import React from 'react';

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-blue-900 to-orange-500 text-white py-6">
      <div className="container mx-auto text-center">
        <div className="mb-4">
          <a href="/" className="flex items-center justify-center space-x-2">
            <span className="bg-gradient-to-r from-blue-500 to-orange-500 bg-clip-text text-transparent text-2xl font-bold">
              ECLIPSE
            </span>
            <span className="text-sm">COMMUNICATIONS LLC</span>
          </a>
        </div>
        <p className="text-sm">&copy; 2025 Eclipse Communications, LLC. All rights reserved.</p>
        <div className="mt-4 space-x-4">
          <a href="#home" className="hover:text-orange-300">Home</a>
          <a href="#about" className="hover:text-orange-300">About</a>
          <a href="#services" className="hover:text-orange-300">Services</a>
          <a href="#portfolio" className="hover:text-orange-300">Results</a>
          <a href="#contact" className="hover:text-orange-300">Contact</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;